<template>
	<div>
		<NavBar :admin="true" :items="items" />
		<v-main>
			<v-container>
				<p class="text-h5" v-translate>Joints</p>
				<v-btn small fab class="mb-3" color="primary" @click="showNewJointForm = !showNewJointForm">
					<v-icon>mdi-plus</v-icon>
				</v-btn>
				<template v-if="showNewJointForm">
					<v-form ref="newJointForm" v-model="validItem">
						<v-row no-gutters>
							<v-col cols="6">
								<v-text-field
									v-model="newJoint.name_pt"
									:label="$gettext('Name') + ' PT'"
									outlined
									class="px-2"
									:rules="[required]"
								></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-text-field
									v-model="newJoint.code"
									:label="$gettext('Code')"
									outlined
									class="px-2"
									:rules="[required]"
								></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-text-field
									v-model="newJoint.name_en"
									:label="$gettext('Name') + ' EN'"
									outlined
									class="px-2"
									:rules="[required]"
								></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-checkbox
									v-model="newJoint.bilateral"
									class="mt-0 pt-0"
									color="primary"
									:label="$gettext('Bilateral')"
									hide-details
								/>
							</v-col>
							<v-col cols="6">
								<v-text-field
									v-model="newJoint.name_es"
									:label="$gettext('Name') + ' ES'"
									outlined
									class="px-2"
									:rules="[required]"
								></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-color-picker hide-inputs v-model="newJoint.color"></v-color-picker>
							</v-col>
						</v-row>
					</v-form>
					<v-row no-gutters class="mb-4">
						<v-spacer></v-spacer>
						<v-btn color="primary" class="mb-2" @click="addJoint">
							<translate>Add</translate>
						</v-btn>
					</v-row>
				</template>
				<v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
				<Joint v-else v-for="joint in joints" :key="joint.id" :joint="joint" @delete-joint="removeJoint" />
			</v-container>
		</v-main>
	</div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import Joint from "@/components/admin/Joint.vue";
import axios from "axios";

export default {
	name: "OsteoSettings",
	components: {
		NavBar,
		Joint
	},
	data: () => ({
		showNewJointForm: false,
		newJoint: {
			name_pt: "",
			name_en: "",
			name_es: "",
			color: "",
			code: "",
			bilateral: false
		},
		showEditItem: false,
		validItem: false,
		itemEdited: {},
		showError: false,
		joints: [],
		loading: false
	}),
	computed: {
		items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: this.$gettext("Osteopathy Settings"),
					disabled: true,
					link: true
				}
			];
		},
		required() {
			return value => !!value || this.$gettext("Required.");
		}
	},
	methods: {
		addJoint() {
			if (this.$refs.newJointForm.validate()) {
				const form = new FormData();
				form.append("name_pt", this.newJoint.name_pt);
				form.append("name_en", this.newJoint.name_en);
				form.append("name_es", this.newJoint.name_es);
				form.append("color", this.newJoint.color);
				form.append("code", this.newJoint.code);
				form.append("bilateral", this.newJoint.bilateral);
				axios
					.post("/osteopathy/joint/new", form)
					.then(response => {
						console.log(response.data);
						if (response.data.result == "ok") {
							this.joints.unshift(response.data.joint);
							this.newJoint.name_pt = "";
							this.newJoint.name_en = "";
							this.newJoint.name_es = "";
							this.newJoint.color = "";
							this.newJoint.code = "";
							this.newJoint.bilateral = false;
							this.showNewJointForm = false;
						}
					})
					.catch(error => console.log(error));
			}
		},
		removeJoint(joint) {
			this.joints.splice(this.joints.indexOf(joint), 1);
		}
	},
	created() {
		this.loading = true;
		axios
			.get("/osteopathy/joints")
			.then(response => {
				if (response.status === 200) {
					console.log(response.data);
					this.joints = response.data;
					this.loading = false;
				}
			})
			.catch(error => console.log(error));
	}
};
</script>